import { type ArticleCardProps } from '3-components/Cards/CardArticle/CardArticle';
import { type ArticleListingQuery } from 'cms/cms';
import HTMLReactParser from 'html-react-parser';
import { resolveCategoriesToBadges } from './badgeResolver';
import { resolveImageReferenceToImage } from './imageResolver';
import type { ContentAreaItemModelSearch, ContentModelReference } from 'cms/cms-types';
import { resolveDate } from './dateResolver';
import { resolveMinRead } from './minReadResolver';
import { resolveAuthorsToCardAuthors } from './authorResolver';

export type ArticlePage = NonNullable<ArticleListingQuery['ArticlePage']>;
export type ArticlePageItems = NonNullable<ArticlePage['items']>;
export interface ArticleCardResolverSettings {
    minReadSuffix: string;
}

export const resolveArticlePagesToArticleCards = (items: ArticlePageItems, settings: ArticleCardResolverSettings): ArticleCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Title, PreviewTitle, PreviewDescription, MediaTypeCategories, PreviewImage, ArticlePublishDate, HidePublishDate, ReadTimeInMins, Authors, ContentLink } = item as NonNullable<typeof item>;
        const tags = resolveCategoriesToBadges(MediaTypeCategories);
        const imgSrcSets = [480, 767];
        const img = resolveImageReferenceToImage(PreviewImage as ContentModelReference, '?width=460', imgSrcSets);
        const date = resolveDate(ArticlePublishDate);
        const minRead = resolveMinRead(ReadTimeInMins, settings?.minReadSuffix ? settings.minReadSuffix : '');
        const authors = resolveAuthorsToCardAuthors(Authors as ContentAreaItemModelSearch[]);

        return {
            ...(ContentLink?.Url && { link: { href: ContentLink.Url } }),
            title: PreviewTitle || Title as string,
            ...(PreviewDescription && { children: HTMLReactParser(PreviewDescription as string) }),
            tags,
            ...(img && { img }),
            date,
            hidePublishDate: HidePublishDate as boolean,
            minRead,
            authors,
        };
    });
};

